module.exports = __webpack_public_path__ + "img/ellipse.359fca15.svg";